import { useEffect } from "react";
import { Trans, useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";

import SmileySpinner from "@/assets/SmileySpinner.svg?react";

export const AuthenticatorDone = () => {
  const navigate = useNavigate();
  // Redirect after 5 seconds
  useEffect(() => {
    setTimeout(() => {
      navigate("/portal/cockpit");
    }, 5000);
  }, [navigate]);

  const { t } = useTranslation();

  return (
    <div className="inline-flex flex-col items-center justify-center gap-10 text-center">
      <h1 className="max-w-[40rem] px-10 text-4xl font-semibold text-primary-100">
        <Trans t={t} i18nKey="portal:authenticator.done.thankYou" />
      </h1>
      <SmileySpinner className="animate-spin" />
      <p className="text-lg text-black">
        {t("portal:authenticator.done.redirectText")}
      </p>
    </div>
  );
};
